import React, { FC, useRef } from 'react';
import TruncateTextCmp from 'src/components/TruncateText';

interface IProps {
    // id of the checkbox this label belongs to, so clicking the text still targets it.
    htmlFor: string;
    // Full service name. Always the tooltip text, even when a shorter label is displayed.
    name: string;
    // Shortened display text, where the step defines one. Defaults to the full name.
    displayName?: string;
    labelClassName?: string;
}

/**
 * ServiceLabel — one additional-service checkbox label in the Book Quote stepper, with a
 * hover tooltip once the text is cut off.
 *
 * This exists because TruncateTextCmp measures the element behind a ref the caller supplies.
 * The service lists render many labels from one .map(), and a single ref declared in the parent
 * is overwritten by every item, leaving all of them measuring whichever element rendered last —
 * so most truncated labels never got their tooltip. Owning the ref inside a per-item component
 * gives every label its own measurement.
 */
const ServiceLabel: FC<IProps> = ({ htmlFor, name, displayName, labelClassName = '' }) => {
    const labelRef = useRef<HTMLParagraphElement>(null);

    return (
        <TruncateTextCmp message={name} refName={labelRef}>
            <p className="truncate" ref={labelRef}>
                <label htmlFor={htmlFor} className={labelClassName}>
                    {displayName ?? name}
                </label>
            </p>
        </TruncateTextCmp>
    );
};

export default ServiceLabel;
